export default __webpack_public_path__ + "static/media/delete-dark.3b3b3b67.svg";